import styled from "@emotion/styled"
import tw from "tailwind.macro"

export const StyledEntitiesContainer = tw.div`
  mx-auto mt-2 mb-12 md:mt-8
`
export const StyledEntitiesList = tw.div`
 flex flex-wrap w-full justify-center mb-12
`
